import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Position_Entity } from "../../entities/position";
import { filmsApi } from "../api/filmsApi";

const positionsAdapter = createEntityAdapter<Position_Entity>();
const initialState = positionsAdapter.getInitialState();

export const positionEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getPositions: build.query<EntityState<Position_Entity>, void>({
      query: () => `positions`,
      transformResponse: (responseData: Position_Entity[]) => {
        return positionsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["positions"],
    }),
    getPosition: build.query<Position_Entity, number>({
      query: (id) => `positions/${id}`,
      providesTags: (result, error, id) => [{ type: "positions", id }],
    }),
    createPosition: build.mutation<Position_Entity, Partial<Position_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `positions`,
      }),
      invalidatesTags: ["positions"],
    }),
    updatePosition: build.mutation<
      void,
      { id: number; body: Partial<Position_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `positions/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "positions", id },
        "positions",
      ],
    }),
    deletePosition: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `positions/${id}`,
      }),
      invalidatesTags: ["positions"],
    }),
  }),
});

export const {
  useGetPositionQuery,
  useGetPositionsQuery,
  useCreatePositionMutation,
  useDeletePositionMutation,
  useUpdatePositionMutation,
} = positionEndpoints;

export default positionEndpoints;
